import { render } from "./DLTestView.vue?vue&type=template&id=5b94fc0e"
import script from "./DLTestView.vue?vue&type=script&lang=js"
export * from "./DLTestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__